import { render, staticRenderFns } from "./IMPlaceSearch.vue?vue&type=template&id=618fa86d&"
import script from "./IMPlaceSearch.vue?vue&type=script&lang=js&"
export * from "./IMPlaceSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports